export default {
  pt: {
    titleClient: "Quase lá",
    titleAdmin: "O que falta?",
    subtitleComplete: "Todos os passos de sua cobertura<br />foram realizados, parabéns!",
    subtitleIncomplete: "Faltam alguns passos para completar<br />o processo de contratação.",
    subtitleShare: "Compartilhe com o cliente para dar<br />continuidade com o processo.",
    messageIncomplete: "Quando você estiver com a bike, continue o processo acessando o link enviado para o seu email!",
    nextButton: "Próximo",
    shareButton: "Compartilhar",
  },

  en: {
    titleClient: "Almost there",
    titleAdmin: "What's missing?",
    subtitleComplete: "All steps of your coverage<br />have been completed, congratulations!",
    subtitleIncomplete: "Some steps are missing to complete<br />the contracting process.",
    subtitleShare: "Share with the client to continue<br />with the process.",
    messageIncomplete: "When you have the bike, continue the process by accessing the link sent to your email!",
    nextButton: "Next",
    shareButton: "Share",
  },
}; 